// Absence Action Types
export const SET_ABSENCE_REASONS = "SET_ABSENCE_REASONS";
export const SET_ABSENCE_LIST = "SET_ABSENCE_LIST";
export const SET_ABSENCE_HOURS_LIST = "SET_ABSENCE_HOURS_LIST";
export const SET_ABSENCE_LIMITS = "SET_ABSENCE_LIMITS";

// Access Codes Action Types
export const SET_ACCESS_CODE = "SET_ACCESS_CODE";
export const SET_ACCESS_CODES_LIST = "SET_ACCESS_CODES_LIST";

// Auth Action Types
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";

// Canteen Report Action Types
export const RESET_CURRENT_REPORT = "RESET_CURRENT_REPORT";
export const SET_REPORT_ID = "SET_REPORT_ID";
export const SET_CURRENT_REPORT = "SET_CURRENT_REPORT";
export const SET_REPORTS_LIST = "SET_REPORTS_LIST";

// Error Action Types
export const SET_ERROR = "SET_ERROR";

// External Unit Action Types
export const SET_CURRENT_EXTERNAL_UNIT = "SET_CURRENT_EXTERNAL_UNIT";
export const SET_EXTERNAL_UNITS_LIST = "SET_EXTERNAL_UNITS_LIST";

// Forms Action Types
export const SET_FORM = "SET_FORM";
export const SET_FORMS_LIST = "SET_FORMS_LIST";

// Meal Action Types
export const SET_MEALS_LIST = "SET_MEALS_LIST";

// Meal Order Action Types
export const SET_MEAL_ORDERS_LIST = "SET_MEAL_ORDERS_LIST";
export const SET_UNSETTLED_MEAL_ORDERS_LIST = "SET_UNSETTLED_MEAL_ORDERS_LIST";

// Meal Reservation Action Types
export const RESET_CURRENT_MEAL_RESERVATION = "RESET_CURRENT_MEAL_RESERVATION";
export const SET_CURRENT_MEAL_RESERVATION = "SET_CURRENT_MEAL_RESERVATION";
export const SET_MEAL_RESERVATIONS_LIST = "SET_MEAL_RESERVATIONS_LIST";

// Menu Action Types
export const SET_DAILY_MENU = "SET_DAILY_MENU";
export const SET_FULL_MENU = "SET_FULL_MENU";

// Occasions Action Types
export const SET_OCCASIONS_LIST = "SET_OCCASIONS_LIST";

// Paycheck Action Types
export const SET_PAYCHECKS_LIST = "SET_PAYCHECKS_LIST";

// Request Action Types
export const SET_CURRENT_REQUEST = "SET_CURRENT_REQUEST";
export const SET_REQUESTS_LIST = "SET_REQUESTS_LIST";
export const UPDATE_REQUEST_CANCELED = "UPDATE_REQUEST_CANCELED";
export const UPDATE_REQUEST_ATTACHMENT = "UPDATE_REQUEST_ATTACHMENT";
export const UPDATE_REQUEST_CONFIRMATIONS = "UPDATE_REQUEST_CONFIRMATIONS";

// Settings Action Types
export const SET_SETTINGS = "SET_SETTINGS";

// Structure Action Types
export const SET_STRUCTURE = "SET_STRUCTURE";
export const SET_UNITS_LIST = "SET_UNITS_LIST";
export const SET_EDIT_UNIT_NAME = "SET_EDIT_UNIT_NAME";
export const SET_EDIT_UNIT_SETTINGS = "SET_EDIT_UNIT_SETTINGS";
export const SET_EDIT_EMPLOYEES_LIST = "SET_EDIT_EMPLOYEES_LIST";
export const SET_EDIT_SUB_UNITS_LIST = "SET_EDIT_SUB_UNITS_LIST";
export const SET_EDIT_SUPERVISORS_LIST = "SET_EDIT_SUPERVISORS_LIST";

// User Action Types
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const SET_SELECTED_USER = "SET_SELECTED_USER";
export const SET_USERS_LIST = "SET_USERS_LIST";

// Working Time Action Types
export const SET_WORKING_TIME_AGREEMENT = "SET_WORKING_TIME_AGREEMENT";
export const RESET_REPORT = "RESET_REPORT";
export const SET_REPORT = "SET_REPORT";
export const SET_REPORTS = "SET_REPORTS";
export const SET_EXTERNAL_REPORTS = "SET_EXTERNAL_REPORTS";